window.addEventListener('scroll', function() {
  if (window.scrollY > 50) {
    document.querySelector('header.header').classList.add('scrolling');
  } else {
    document.querySelector('header.header').classList.remove('scrolling');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var customSizeInputs = document.querySelectorAll('.custom_size_option_addon_input input');

  customSizeInputs.forEach(function(input) {
    input.addEventListener('keyup', function() {
      var inputSize = this.getAttribute('data-name');
      var sSize = document.querySelector('span[data-size-name="' + inputSize + '"]');
      sSize.innerHTML = this.value;
    });
  });
});



window.addEventListener("load", function() {
    var body = document.querySelector('body');
    var radioInputs = document.querySelectorAll('input[type="radio"][name="Type"]');
    var sizeRadioInputs = document.querySelectorAll('input[type="radio"][name="Size"]');
    var customSizeInputs = document.querySelector('input[type="radio"][value="Custom"]');
    var addOnOption = document.querySelector('.custom_size_option_addon');
    var addOnOptionInputs = document.querySelectorAll('.custom_size_option_addon input');
    var customSizeOptionOutputs = document.querySelectorAll('.custom_size_option_addon_img  span[data-size-name]');
    var ymqBoxes = document.querySelectorAll('.ymq-options-box');
    var sizeFieldset = document.querySelector('input[type="radio"][name="Size"]').closest('fieldset');
    var ymqFirstBox = document.querySelector('.ymq-options-box');
    var customStyleOption = document.querySelector('.custom-style-options');
    var customStyleOptionInput = document.querySelectorAll('.custom-style-options input');
    var customStyleOptionInputChecked = document.querySelector('.custom-style-options input:checked');
    var hiddenStyleInput = document.getElementById('hidden_style_input');
    var selectedStyleOption = document.querySelector('input[name="properties[Style]"]:checked');
    var Customtextarea = document.getElementById('custom-note-textarea');
    addOnOptionInputs.forEach(function(input) {
        input.disabled = true;
    });
    Customtextarea.value = '';
    customStyleOptionInput.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      var checkedValues = [];
      
      customStyleOptionInput.forEach(function (checkbox) {
        if (checkbox.checked) {
          checkedValues.push(checkbox.value);
        }
      });
  
      hiddenStyleInput.value = checkedValues.join(', '); // You can customize the delimiter as needed
    });
  });


  
    function updateSizeFieldset() {
     if (selectedStyleOption && hiddenStyleInput) {
  // Set the value of the hidden input to the value of the checked radio button
  hiddenStyleInput.value = selectedStyleOption.value;
  console.log("Assigned value to hidden input: " + hiddenStyleInput.value);
} else {
  console.log("No radio button is checked, or the hidden input is not found.");
}
    var selectedValue = document.querySelector('input[type="radio"][name="Type"]:checked').value;

      if (selectedValue === "Unstitched") {
        body.classList.add('add-lining');
        body.classList.remove('express-stitching-custom');
        hiddenStyleInput.value = '';
        Customtextarea.value = '';
         addOnOptionInputs.forEach(function(input) {
              input.disabled = true;
          });
        sizeRadioInputs[0].click(); 
        sizeFieldset.style.display = 'none';
        customStyleOption.style.display = 'none';
        customStyleOptionInput.forEach(function(input) {
              input.disabled = true;
          });
      }else{
        sizeRadioInputs[2].click();
        body.classList.remove('add-lining');
        body.classList.add('express-stitching-custom');
        sizeRadioInputs.forEach(function (input) {
          input.classList.remove('disabled');
        })
        sizeFieldset.style.display = 'block';
        customStyleOption.style.display = 'block';
         customStyleOptionInput.forEach(function(input) {
              input.disabled = false;
          });
      }    
  }
  if(customSizeInputs){
    customSizeInputs.addEventListener('click', function () {
      addOnOption.style.display = 'block';
       addOnOptionInputs.forEach(function(input) {
              input.disabled = false;
          });
    })
  }
  updateSizeFieldset()

   radioInputs.forEach(function(radio) {
    radio.addEventListener("change", updateSizeFieldset);
  });

     radioInputs.forEach(function(radio) {
    radio.addEventListener("click", function(){
    addOnOption.style.display = 'none'; 
       addOnOptionInputs.forEach(input => {
         input.value = '';
        });
        customSizeOptionOutputs.forEach(output => {
              output.innerText = '';
          });
    });
  });

sizeRadioInputs.forEach(function(radio, index) {
    if (index !== sizeRadioInputs.length - 1) {
        radio.addEventListener("click", function () {
        addOnOption.style.display = "none";
        addOnOptionInputs.forEach(input => {
         input.value = '';
        });
        customSizeOptionOutputs.forEach(output => {
              output.innerText = '';
          });
        });
    }
});

  
  if(customSizeInputs){
customSizeInputs.addEventListener('click', function() {
    addOnOption.style.display = "block";
      console.log("your code is running my boy")
  
    var customSizesInputs = document.querySelectorAll('.custom_size_option_addon_input input');
    var addToCartButton = document.querySelector('button.product-form__submit');
    setTimeout(function() {
      console.log("your code is running my boy")
      addToCartButton.disabled = true;
    }, 1000);

    customSizesInputs.forEach(function(input) {
      input.addEventListener('input', toggleAddToCartButton);
    });
   addOnOptionInputs.forEach(function(input) {
      input.disabled = false;
  });
  
    function toggleAddToCartButton() {
      var allInputsHaveValue = Array.from(customSizesInputs).every(input => input.value.trim() !== '');    
      addToCartButton.disabled = !allInputsHaveValue;
    }
}) 
}
})


// document.addEventListener('DOMContentLoaded', function() {
//   document.addEventListener('animationstart', function(event) {
//     if (event.animationName === 'nodeInserted') {
//       var ratingContent = document.getElementsByClassName("spb-label-tooltip");
//       if (ratingContent.length > 0) {
//         moveMainDiv();
//         flowcode();
//       }
//     } else {
//       moveMainDiv();
//       flowcode();
//     }
//   }, true);

//   var option1Inputs = document.querySelectorAll("input[name='Type']");
//   option1Inputs.forEach(function(input) {
//     input.addEventListener('change', function() {
//       flowcode();
//     });
//   });

//   function moveMainDiv() {
//     var mainDiv = document.querySelector('#infiniteoptions-container');
//     var customStyleOptionsDiv = document.querySelector('.custom-style-options');
    
//     if (mainDiv && customStyleOptionsDiv) {
//       var parentDiv = customStyleOptionsDiv.parentNode;

//       parentDiv.insertBefore(mainDiv, customStyleOptionsDiv.nextSibling);
//     }
//   }

//   function flowcode() {
//     var checkedValue = document.querySelector("input[name='Type']:checked").value;
//     var liningFieldset = document.querySelector("input[name='properties[infinite_options_1]']").closest("fieldset");
//     var siblingTooltip = document.querySelector("input[name='properties[Express Stitching]']").closest("fieldset");

//     if (checkedValue === 'Stitched') {
//       if (liningFieldset) {
//         liningFieldset.style.display = 'none';
//         siblingTooltip.classList.remove("main");
//       }
//       if (siblingTooltip) {
//         siblingTooltip.style.display = 'block';
//         liningFieldset.classList.add("main");
//       }
//     } else if (checkedValue === 'Unstitched') {
//       if (liningFieldset) {
//         liningFieldset.style.display = 'block';
//       }
//       if (siblingTooltip) {
//         siblingTooltip.style.display = 'none';
//       }
//     }
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
     addOnOptionInputs.forEach(function(input) {
        input.disabled = true;
    });
});
